import axios from 'axios'
import { ElMessage } from 'element-plus'
import { isCheckTimeout } from '@/utils/auth'
import {typeOf} from "@/utils/scripts"
import store from '../store/index'
import {v4 as uuidv4} from "uuid"

console.log('env====', process.env)

axios.defaults.baseURL = process.env.VUE_APP_BASE_API
// axios.defaults.timeout = 5000 // request timeout
// 添加请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 登录时间超时

    const token = window.localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = token
    }

    if(config.method == "post" && !config.data ) {
      config.data = {}
    }

    // 添加请求唯一ID
    if(typeOf(config.data) === "Object") {
      config.data['requestId'] = uuidv4()
    }

    // 在发送请求之前做些什么
    return config
  },
  (error) => {
    // 对请求错误做些什么
    ElMessage(error)
    return Promise.reject(error.message)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.data.code == 200) {
      return response
    }

    switch (response.data.code) {
      // 对得到的状态码的处理，具体的设置视自己的情况而定
      case 400:
        ElMessage.error(response.data.msg)
        break
      case 401:
      case 403:
        ElMessage.error('登录已过期，请重新登录')
        localStorage.clear()
        setTimeout(() => {
          location.replace(`${origin}`)
        }, 200);
        break
      case 404:
        ElMessage.error('资源不存在')
        break
    }
    return Promise.reject()
  },
  (error) => {

    // 对响应错误做点什么
    switch (error) {
      // 对得到的状态码的处理，具体的设置视自己的情况而定
      case 400:
        ElMessage.error('错误')
        break
      case 401:
        ElMessage.error('权限过期了')
        break
      case 403:
        ElMessage.error('没有权限')
        break
      case 404:
        ElMessage.error('资源不存在')
        break
      case 500:
        ElMessage.error('服务器忙碌')
        break
      default:
        ElMessage.error('出错了')
        break
    }

    return Promise.reject(error)
  }
)

export const mypost = (url, data, config) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: `${url}`,
      data,
      ...config
    })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
export const myget = (url, data, config) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${url}`,
      params: data,
      ...config
    })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default axios
